var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 2.66797H13.3333C14.0666 2.66797 14.6666 3.26797 14.6666 4.0013V12.0013C14.6666 12.7346 14.0666 13.3346 13.3333 13.3346H2.66659C1.93325 13.3346 1.33325 12.7346 1.33325 12.0013V4.0013C1.33325 3.26797 1.93325 2.66797 2.66659 2.66797Z",
    stroke: "#7C21FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 4L7.99992 8.66667L1.33325 4",
    stroke: "#7C21FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.49ab690a9ca66e941bedeb78b3c886ba.svg";
export { ForwardRef as ReactComponent };